import React from "react";
import { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import parse from "html-react-parser";
import HelpContext from "../shared/context/HelpProvider";
const baseURL = process.env.REACT_APP_API_JOBS;

function HelpModal() {
  const { showHelp, setShowHelp, saeef } = useContext(HelpContext);
  const [help, setHelp] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "help?" + "saeef=" + saeef,
          {
            signal: controller.signal,
          }
        );
        isMounted && setHelp(response.data[0]);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  }, [showHelp]);

  return (
    <>
      <Modal
        show={showHelp}
        onHide={() => setShowHelp(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {"עזרה" + ": "}
            {help ? help.perek : " "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {parse(help ? help.details1 : " ")}
          <br />
          {parse(help?.details2 ? help.details2 : " ")}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HelpModal;
